import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.planning')
  .factory('$planning', planningObjectFactory);

/* @ngInject */
function planningObjectFactory($bringozFactory: $bringozFactory,
                               PlanningAPI: BringozApi) {

  function $planning(id: string) {
    return $bringozFactory(id, PlanningAPI)
  }

  return $planning
}
